package com.mithkumaran.utils

import com.mithkumaran.models.ExperienceModel
import com.mithkumaran.models.LinkedinRecommendationModel
import com.mithkumaran.models.ProjectModel
import com.mithkumaran.models.SkillModel

object DataRepository {
    fun getSkills() = ArrayList<SkillModel>().apply {
        add(SkillModel(drawable = Res.Drawable.ANDROID, title = "Android"))
        add(SkillModel(drawable = Res.Drawable.JAVA, title = "Java"))
        add(SkillModel(drawable = Res.Drawable.KOTLIN, title = "Kotlin"))
        add(SkillModel(drawable = Res.Drawable.ANDROID_JETPACK, title = "Jetpack"))
        add(SkillModel(drawable = Res.Drawable.JETPACK_COMPOSE, title = "Compose"))
        add(SkillModel(drawable = Res.Drawable.KOTLIN_MULTIPLATFORM, title = "KMP"))
        add(SkillModel(drawable = Res.Drawable.JSON, title = "JSON"))
        add(SkillModel(drawable = Res.Drawable.FIGMA, title = "Figma"))
        add(SkillModel(drawable = Res.Drawable.FIREBASE, title = "Firebase"))
        add(SkillModel(drawable = Res.Drawable.GIT, title = "Git"))
        add(SkillModel(drawable = Res.Drawable.HTML, title = "HTML"))
        add(SkillModel(drawable = Res.Drawable.ANDROID_STUDIO, title = "Android Studio"))
        add(SkillModel(drawable = Res.Drawable.INTELLIJ, title = "IntelliJ"))
        add(SkillModel(drawable = Res.Drawable.POSTMAN, title = "Postman"))
        add(SkillModel(drawable = Res.Drawable.VSCODE, title = "VSCode"))
        add(SkillModel(drawable = Res.Drawable.MARKDOWN, title = "Markdown"))
    }

    fun getExperiences() = ArrayList<ExperienceModel>().apply {
        add(
            ExperienceModel(
                designation = "Pharmacy",
                employerName = "Britannia",
                duration = "Sept 23 - Sept 24",
                logo = Res.Drawable.HSBC,
                roleAndResponsibilities = "Counter assitant"
            )
        )
    }


}